export default {
  init() {
    // JavaScript to be fired on all pages

    // Cookie Consent
    window.addEventListener('load', function () {
      window.cookieconsent.initialise({
        'palette': {
          'popup': {
            'background': '#61287e',
          },
          'button': {
            'background': 'transparent',
            'text': '#ffffff',
            'border': '#ffffff',
            'color': '#007c8c',
          },
        },
        'content': {
          'href': '/privacy-policy',
        },
      })
    });

    // Smooth scroll
    $('a.smooth-scroll, .smooth-scroll a').click(function (event) {
      if (this.hash !== '') {
        event.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top,
        }, 600, function () {
          window.location.hash = hash;
        });
      }
    });

    // Wales Map Tooltip
    const map = $('#wales-map');
    const tooltip = map.find('.county-tooltip');
    const counties = map.find('.county-link');
    for (let i = 0; i < counties.length; i++) {
      const county = $(counties[i]);
      county.hover(
        () => {
          const title = county.find('title').html();
          const text = tooltip.text();
          if (title) {
            if (text) {
              tooltip.fadeOut(200, function () {
                tooltip.text(title).fadeIn(200);
              });
            } else {
              tooltip.text(title).fadeIn();
            }
          }
        },
        () => {
          tooltip.stop();
          tooltip.hide();
        }
      );
    }

    // On scroll
    $(window).scroll(function () {
      const scrollTop = $(window).scrollTop();
      const offset = 300;
      let opacity = 1;
      let marginTop = 0;
      if (offset > scrollTop) {
        opacity = 1 - scrollTop / offset;
        marginTop = scrollTop * 0.8;
      } else {
        opacity = 0;
        marginTop = 300;
      }
      $('.header-cover .wp-block-cover__inner-container').css({
        'top': marginTop,
        'opacity': opacity,
        'padding-top': $('#header').height(),
      });
    });

    $('.navbar-toggler').click(function () {
      $('#header .background').toggleClass('show');
    });

    // Magnific Popup Gallery
    $('.popup-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
    });

    $('.open-popup-link').magnificPopup({
      type: 'inline',
      midClick: true,
      callbacks: {
        open: function () {
          $('html').css('margin-right', 0);
          $(this.content).find('video')[0].play();

        },
        close: function () {
          $(this.content).find('video')[0].load();
        },
      },
    });

    // Check if an elemnt is in viewport
    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    // Animate stats when in viewport
    $(window).on('scroll load', function () {
      $('.number.animate-once').each(function () {
        let total = $(this).data('count');
        if (isScrolledIntoView(this) === true) {
          $(this)
            .prop('Counter', 0)
            .animate(
              {
                Counter: total,
              },
              {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                  $(this).text(Math.ceil(now));
                },
                complete: function () {
                  $(this).text(total);
                  $(this).removeClass('animate-once');
                },
              }
            );
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Set padding on body for fixed header
    if (!$('.cover-image-header').length) {
      $(window).on('load', function () {
        const headerHeight = $('#header').outerHeight();
        $('body').css('padding-top', headerHeight);
        $(window).resize(function () {
          const headerHeight = $('#header').outerHeight();
          $('body').css('padding-top', headerHeight);
        });
      });
    }

    if (window.pageYOffset >= 400) {
      headerMetaAnimationScrolled()
    } else {
      headerMetaAnimationTop();
    }

    // When the user scrolls the page, execute header animation 
    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= 400) {
        headerMetaAnimationScrolled()
      } else {
        headerMetaAnimationTop();
      }
    });

    // Change the header-meta on the main nav
    function headerMetaAnimationScrolled() {
      let headerColour = $('#header .background').data('colour');
      if (!headerColour) {
        headerColour = '#61287e';
      }

      $('#header .background').css('opacity', 1);
      // $('#header .dropdown-menu').css('background-color', headerColour);
      $('#header .language-column').css('height', 0);
      $('#header .brand img').css('height', '50px');
    }

    // Change the header-meta on the main nav
    function headerMetaAnimationTop() {
      $('#header .background').css('opacity', 0);
      // $('.cover-image-header #header .dropdown-menu').css('background-color', 'transparent');
      $('#header .language-column').css('height', '37px');
      $('#header .brand img').css('height', '80px');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js